import React, { forwardRef, useContext, useState } from 'react';
import styled from 'styled-components';
import IEditableProps from 'src/utilities/IEditableProps';
import IStyledProps from 'src/utilities/IStyledProps';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import playCircleIcon from "../../icons/play-circle.svg";
import { AutomationTestIdElementType, AutomationTestIdFeature, createDataTestId } from '../../utilities/automation';
import YoutubeModal from '../Modals/YoutubeModal';
import ModalContext from '../../context/ModalContext';
import { getUniqueModalId } from '../Modals/BaseModal';

export interface IVideoButtonProps extends IEditableProps, IStyledProps {
   children;
   videoId: string;
   variant: "link" | "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "dark" | "light" | "outline-primary" | "outline-secondary" | "outline-success" | "outline-danger" | "outline-warning" | "outline-info" | "outline-dark" | "outline-light";
   outline: boolean;
   mute?: boolean;
   autoPlay?: boolean;
   subtitles?: boolean;
   loop?: boolean;
   cmsId?: string;
}

export default styled(forwardRef((props: IVideoButtonProps, ref: any) => {
   const { openModal } = useContext(ModalContext);
   const { editorClassObj, className, cmsId, outline = false, variant = '' } = props;
   const [ uniqueModalId ] = useState(getUniqueModalId());

   return (
      <>
         <Button
            type="button"
            className={classNames('blur d-flex btn align-items-center', className, editorClassObj)}
            ref={ref}
            data-id={cmsId}
            data-test-id={createDataTestId({ feature: AutomationTestIdFeature.HERO, element: AutomationTestIdElementType.BUTTON, specifier: 'videoButton' })}
            variant={`${outline ? "outline-" : ""}${variant}` as "link" | "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "dark" | "light" | "outline-primary" | "outline-secondary" | "outline-success" | "outline-danger" | "outline-warning" | "outline-info" | "outline-dark" | "outline-light"}
            {...(!cmsId && { onClick: () => openModal(uniqueModalId) })}
         >
            <span className="play-icon" />
            <span className="play-text">{props.children}</span>
         </Button>

         <YoutubeModal
            videoId={props.videoId}
            autoPlay={props.autoPlay}
            subtitles={props.subtitles}
            mute={props.mute}
            loop={props.loop}
            modalId={uniqueModalId}
         />
      </>
   )
}))`

   border-width: 0;
   border-radius: 32px;
   margin: auto auto 1rem 1rem;
   padding: 4px 8px;
   background-color: rgba(255, 255, 255, 0.1);
   z-index: 1;
   -webkit-backdrop-filter: blur(10px);
   backdrop-filter: blur(10px);

   @media (max-width: 990px) {
      margin: auto auto 1rem auto;
   }

   .play-icon {
      display: inline-block;
      background: transparent url(${playCircleIcon}) center center no-repeat;
      width: 2rem;
      height: 2rem;
   }
   .play-text {
      display: inline-block;
      color: #fff;
      margin: 0 0.889rem 0 0.667rem;
      font-size: 0.889rem;
      line-height: 1.11rem;
   }
`